import { addNewpost } from "../Utils/ReducerActions";
const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_USER":
      return { ...state, loginUser: action.payload };

    case "FETCH_CHANNEL":
      return { ...state, channels: action.payload };

    case "SHOW_MODAL":
      return { ...state, modalFlag: action.payload, DropDownModal: false };

    case "HIDE_MODAL":
      return { ...state, modalFlag: action.payload, joinChannelModal: false };

    case "FETCH_CHANNEL_NAME":
      return {
        ...state,
        channelName: action.payload,
        loadedMember: true,
        nameDisplayHeader: action.payload,
      };

    case "FETCH_CHANNEL_USERS":
      return { ...state, channelMember: action.payload, loadedMember: true };

    case "FETCH_SPECIFIED_CHANNEL":
      return { ...state, specifiedChannel: action.payload, loadedMember: true };

    case "SHOW_ALL_CHANNEL":
      return {
        ...state,
        loadedMember: action.payload,
        nameDisplayHeader: "random",
      };

    case "FETCH_ONE_CHANNEL_POSTS":
      return {
        ...state,
        posts: action.payload,
        loadedMember: true,
      };

    case "FETCH_RANDOM_POSTS":
      return {
        ...state,
        posts: action.payload,
        loadedMember: false,
      };

    case "ADD_NEW_POST":
      return addNewpost({ state, action });

    case "RESIZE_SCREEN":
      return {
        ...state,
        resizeFlag: action.payload,
      };

    case "SHOW_TIMES_ICON":
      return {
        ...state,
        showTimesIcon: action.payload,
      };

    case "SHOW_DROP_DOWN":
      return {
        ...state,
        DropDownModal: action.payload,
        joinChannelModal: false,
      };

    case "FETCH_ALL_CHANNEL_TO_JOIN":
      return {
        ...state,
        allChannelsToJoin: action.payload,
      };

    case "DISPLAY_CHANNELS_TO_JOIN":
      return {
        ...state,
        joinChannelModal: action.payload,
        DropDownModal: false,
        modalFlag: false,
      };

    case "NEW_CHANNEL":
      return {
        ...state,
        channels: [...state.channels, action.payload],
      };

    default:
      return state;
  }
};

export default reducer;
